/**
 * Generation utilities for render operations
 */

/**
 * Maximum value for seed generation
 * Seeds are used to ensure reproducible render results
 */
export const MAX_SEED_VALUE = 1000000;

/**
 * Generate a random seed for render operations
 * @returns Random integer between 0 and MAX_SEED_VALUE
 */
export const generateSeed = (): number =>
  Math.floor(Math.random() * MAX_SEED_VALUE);
